import applePay from "../../../assets/images/apple_pay.svg";
import googlePay from "../../../assets/images/google_pay.svg";
import samsungPay from "../../../assets/images/samsung_pay.svg"; 
import masterCard from "../../../assets/images/Cards-icons/mastercard.svg";
import visaCard from "../../../assets/images/Cards-icons/visa.svg";
export const features = [
  {
    label: "Apple Pay",
    value: "Apple Pay",
    icon: applePay,
  },
  {
    label: "Google Pay",
    value: "Google Pay",
    icon: googlePay,
  },
  {
    label: "Samsung Pay",
    value: "Samsung Pay",
    icon: samsungPay,
  },
];
export const paymentMethod = [
    {
      label: "Mastercard",
      value: "Mastercard",
      icon: masterCard,
    },
    {
      label: "VISA",
      value: "VISA",
      icon: visaCard,
    }, 
  ];
export const cardServiceOption =[
    "Last 4 digits of SSN [for US only]", "SSN [for US only]","ZIP code","Last 4 digits of Mobile Number",
    "Expiration Date","Access Code","Security Code","Date of Birth","PIN Code","Tax ID (Available for Web only)",

]
export const verificationToChangePin = [
    "Expiry Date", "Last 4 digits of SSN [for US only]",  "Date of Birth", "Password"
];
export const cardActivationMethod = ["API", "IVR", "CSR", "At the time of enrollment"];
export const validationInfo = ["Last 4 digits of SSN [for US only]", "SSN [for US only]", "ZIP code", "Last 4 digits of Mobile Number",
    "Expiration Date", "Access Code", "Security Code", "Date of Birth", "PIN Code", "Tax ID"]
export const userCreationInfo = ["Last 4 digits of SSN [for US only]", "SSN [for US only]", "ZIP code",
    "Last 4 digits of Home Phone Number", "Last 4 digits of Mobile Number", "Expiration Date", "Access Code", "Security Code", "Date of Birth", "PIN Code", "Tax ID"]
export const profileVerification = ["Access Code", "Expiry", "Date of Birth", "PIN Code", "Last 4 digits of SSN [for US only]", "Last 4 digits of Home Phone Number"]
export const creditPaymentFeature = [
  { feature: 'Make Payments', alternativeMethod: '', enabled: false },
  { feature: 'Scheduled Payments', alternativeMethod: '', enabled: false },
  { feature: 'Payment Activity', alternativeMethod: '', enabled: false },
  { feature: 'Payment Preferences', alternativeMethod: '', enabled: false },
];
export const myAccountFeature = [
  { feature: 'Account Summary', alternativeMethod: '', enabled: false },
  { feature: 'Account Activity', alternativeMethod: '', enabled: false },
  { feature: 'Account Statements', alternativeMethod: '', enabled: false },
  { feature: 'Block/Reissue Cards', alternativeMethod: '', enabled: false },
  { feature: 'Upgrade Card Program', alternativeMethod: '', enabled: false },
];